// extracted by mini-css-extract-plugin
export default {"root":"DemoAccessExpiredWidget_root__3+3bg","buyButton":"DemoAccessExpiredWidget_buyButton__cJc5G"};